import { useState } from "react";

function useFormValidation() {
  const validateForm = (categoryName, rows, isSetMenu, fileList) => {
    // Validate category name
    if (!categoryName.trim()) {
      return {
        isValid: false,
        errorMessage: "Category name is required",
      };
    }

    // if categoryName only special character than validation display validation message
    const specialCharRegex = /^[^a-zA-Z0-9]+$/;
    if (specialCharRegex.test(categoryName.trim())) {
      return {
        isValid: false,
        errorMessage: "Category name cannot contain only special characters",
      };
    }

    // if (fileList.length === 0) {
    //   return {
    //     isValid: false,
    //     errorMessage: "Category Image is required",
    //   };
    // }

    // If isSetMenu is true, allow empty variants (no validation needed for variants)
    if (isSetMenu) {
      return {
        isValid: true,
        errorMessage: null,
      };
    }

    // Validate rows
    if (rows.length === 0) {
      return {
        isValid: false,
        errorMessage: "At least one row is required",
      };
    }

    // Check for rows where both name and weight are empty
    const emptyNameAndWeight = rows.some(
      (row) => !row.name.trim() && !row.weight.trim()
    );

    if (emptyNameAndWeight) {
      return {
        isValid: false,
        errorMessage: "Name and weight can't both be empty",
      };
    }

    // Check for rows where either name or weight is empty
    const missingNameOrWeight = rows.some(
      (row) => !row.name.trim() || !row.weight.trim()
    );

    if (missingNameOrWeight) {
      return {
        isValid: false,
        errorMessage: "Name and weight are both required for each row",
      };
    }

    // Additional validation for variant units
    const invalidUnits = rows.some((row) => parseFloat(row.weight) <= 0);

    if (invalidUnits) {
      return {
        isValid: false,
        errorMessage: "Variant units must be greater than zero",
      };
    }


    // Name cannot be only special characters
    const invalidName = rows.some((row) => {
      const name = row.name.trim();

      // If name is not empty and contains NO letters or numbers → invalid
      return name !== "" && !/[A-Za-z0-9]/.test(name);
    });

    if (invalidName) {
      return {
        isValid: false,
        errorMessage: "Name cannot contain only special characters",
      };
    }


    return {
      isValid: true,
      errorMessage: null,
    };
  };

  return { validateForm };
}

export default useFormValidation;
